<!--
 * @Description: 一级科室详情组件
 * @Author: gaohc
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="dep-details-dialog" width="600px" :title="dialogTitle"
      :visible.sync="visible" :close-on-click-modal="false"
      @open="initData" :before-close="handleCancel" center>
      <div class="dialog-body first-level-dep-wrap">
        <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
          <el-form-item label="所属医院：" prop="hospitalName">
            <el-select size="small" @change="handelChangeHospital" style="width: 240px"
              placeholder="请输入/选择" clearable v-model="formData.hospitalName"
              filterable value-key="id" :disabled="mode == 'edit'"
              :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
								'hspList', srcHspList, this))"
              @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
								visible, 'hspList', srcHspList, this)">
              <el-option v-for="item in hspList" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务机构：">
            <el-select size="small" style="width: 240px" v-model="formData.institutionName"
              placeholder="请输入/选择" clearable filterable @change="changeInst"
              :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value,
								'instList', srcInstList, this))"
              @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
								visible, 'instList', srcInstList, this)">
              <el-option v-for="(item, key) in instList" :key="key"
                :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="mode == 'add'" label="一级科室：" key="2" prop="departmentName">
            <el-select size="small" style="width: 240px" placeholder="请输入/选择" clearable
              v-model.trim="formData.departmentName" @change="handleChangeDep"
              filterable allow-create>
              <el-option v-for="item in departmentList" :key="item.id"
                :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else label="一级科室：" key="3" prop="departmentName">
            <el-input size="small" clearable style="width: 240px"
              v-model.trim="formData.departmentName" placeholder="请输入科室名称">
            </el-input>
          </el-form-item>
          <el-form-item label="科室序号：" prop="ontLevelSort">
            <el-input size="small" clearable @input="limitInput($event)" style="width: 240px"
              v-model.trim="formData.ontLevelSort" placeholder="请输入科室序号">
            </el-input>
          </el-form-item>
          <div class="tips-text">
						序号越大 科室越靠前，序号支持保留一位小数
					</div>
        </el-form>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">
					取 消
				</el-button>
        <el-button type="primary" style="margin-left: 45px" @click="handleSubmit">
					保 存
				</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
import Constant from "@/global/Constant.js";

let id = 1000;
export default {
  name: "DepartmentTree",
  props: ["visible", "mode", "hspName", "hspId", "oneLevelDep"],

  data() {
    let valitSortNumber = (_rule, value, callback) => {
      if (value && value * 1 > 100000) {
        callback(new Error("最大值不能超过100000"));
      } else {
        callback();
      }
    };
    return {
      departmentList: [],
      instList: [],
      srcInstList: [],
      hspList: [],
      srcHspList: [],
      formData: {},
      adminType: null, //管理员类别
      rules: {
        hospitalName: [
          {
            required: true,
            message: "请选择所属医院",
            trigger: ["blur"],
          },
        ],
        departmentName: [
          {
            required: true,
            message: "请选择或输入一级科室名称",
            trigger: ["blur"],
          },
        ],
        ontLevelSort: [
          {
            required: true,
            message: "请输入科室序号",
            trigger: ["blur"],
          },
          {
            validator: valitSortNumber,
            trigger: "blur",
          },
        ],
        institutionName: [
          {
            required: true,
            message: "请选择服务机构",
            trigger: ["blur"],
          },
        ],
      },
    };
  },

  computed: {
    dialogTitle() {
      switch (this.mode) {
        case "add":
          return "新增一级科室";
        case "edit":
          return "编辑一级科室";
        case "details":
          return "一级科室详情";
        default:
          return "----";
      }
    },

    readonly() {
      return this.mode == "edit";
    },
  },
  methods: {
    limitInput(value) {
      this.formData.ontLevelSort = Util.limitInputNumberOrDecimal(value);
    },

    //新增二级科室
    handleAddSecondDep(item) {
      this.$emit("add-secondDep", item.id, item.hospitalId, item.name, "depTree");
    },

    changeInst(val) {
      this.$forceUpdate();   //强制input更新用户输入值
      if (!val) return
      
      this.formData.institutionId = Util.searchKeyWithValueInArr("name", val, this.instList).id;
    },

    handelChangeHospital(val) {
      if (!val) return;
      this.$forceUpdate();
      this.formData.hospitalId = Util.searchKeyWithValueInArr("name", val, this.hspList).id;
      this.getInstAndDepListDo();
    },

    handleChangeDep(val) {
      if (!val) return;
      let depObj = Util.searchKeyWithValueInArr("name", val, this.departmentList);
      this.formData.departmentId = depObj.id ? depObj.id : 0;
    },

    handlePointOutSetSecendDep(dep) {
      this.$confirm(dep.name + "保存成功，快去新增子科室/病房吧~", "提示", {
        confirmButtonText: "新 增",
        cancelButtonText: "取 消",
        customClass: "message-box",
        type: "success",
      }).then(() => {
          this.handleAddSecondDep(dep);
			});
    },

    // 一级科室名称存在时弹窗提示
    showExistsdepartmentNameTips() {
      let tel = this.formData.platformPhone[0];
      let telText = "<span style='color:#0057E0'>" + tel + "</span>";
      let message = this.formData.hospitalName + "医院已存在" + this.formData.departmentName +
        "，不能重复新增！请联系平台管理员 (" + telText + ") 协助核实科室信息吧！";
      this.$alert(message, "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确 定",
        customClass: "message-box",
        type: "warning",
      }).then(() => {
          this.formData.departmentName = "";
			});
    },

    // 获取科室名称是否重复
    getdepartmentNameIsRepeat() {
      let params = {
        hospitalId: this.formData.hospitalId,
        level1DepartmentName: this.formData.departmentName,
        level1DepartmentId: this.formData.departmentId,
      };
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_LEVEL_1DEPARTMENT_NAME_IS_REPEAT,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        if (result.data) {
          this.showExistsdepartmentNameTips();
        } else {
          this.handleSaveLevel1Dep();
        }
      });
    },

		// 一级科室信息提交
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) return;
        if ((this.adminType == 2 || this.adminType == 3) && !this.formData.institutionId) {
          this.$message({
            message: '请选择服务机构',
            type: 'warning'
          });
          return
        }
        this.getdepartmentNameIsRepeat();
      });
    },

    handleSaveLevel1Dep() {
      let method = this.mode == "add" ? "POST" : "PUT";
      let url = this.mode == "add" ? Constant.URL_SAVE_LEVEL_1DEPARTMENT
				: Constant.URL_UPDATE_LEVEL_1DEPARTMENT;
      let param = {
        department: {
          category: 1,
          hospitalId: this.formData.hospitalId,
          level: 1,
          name: this.formData.departmentName,
          ontLevelSort: this.formData.ontLevelSort * 1,
        }
      };
      param.institutionId = this.formData.institutionName ? this.formData.institutionId : 0;
      if (this.mode == "edit") {
        param.department.id = this.oneLevelDep.id;
      } else {
        param.department.id = this.formData.departmentId;
      }
			let [header, esParam] = this.encryptionUtil.encryptAndSignBody(param,
				Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: method,
        url: url,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        if (this.mode == "add") this.handlePointOutSetSecendDep(result.data);
        this.$emit("close-dialog", true);
      });
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    async initData() {
      this.clearData();
      this.clearVaild();
      await this.getLevel1DepDo();
    },

    //查询一级科室新增或编辑Do
    getLevel1DepDo() {
      return new Promise((resolve) => {
        let url = this.mode == "edit" ? Constant.URL_GET_LEVEL_1DEPARTMENT_DO4UPDATE : 
          Constant.URL_GET_LEVEL_1DEPARTMENT_DO4ADD;
        let params = {departmentId: this.oneLevelDep.id};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: url,
          param: this.mode == "edit" ? params : {},
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then((result) => {
          if (result == null) {
						return
					}

					this.formData = result.data;
					this.adminType = result.data.adminType;
					this.hspList = result.data.hospitalList;
					this.srcHspList = result.data.hospitalList;
          
          if(this.mode == "add" && this.hspName){
            this.formData.hospitalName = this.hspName;
            this.formData.hospitalId = this.hspId;
            this.getInstAndDepListDo();
          }
					
          if (this.mode == "edit") {
						this.instList = result.data.institutionList;
						this.srcInstList = result.data.institutionList;
					}
					resolve();
        })
      });
    },

    //查询医院下机构及科室DO
    getInstAndDepListDo() {
      return new Promise((resolve, reject) => {
        let params = {hospitalId: this.formData.hospitalId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_LEVEL_1DEPARTMENT_DO4SELECT_HOSPITAL,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          this.departmentList = result.data.department1List;
          this.srcDepList = result.data.department1List;
          this.instList = result.data.institutionList;
          if (this.instList.length == 1) {
            this.formData.institutionName = this.instList[0].name;
            this.formData.institutionId = this.instList[0].id;
          } else {
            this.formData.institutionName = null;
          }

          this.srcInstList = result.data.institutionList;
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    //初始化打开时去除表单验证
    clearVaild() {
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },

    clearData() {
      this.formData = {};
      this.instList = [];
      this.departmentList = [];
      this.srcInstList = [];
      this.srcDepList = [];
    }
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.first-level-dep-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;
}

.dialog-footer {
  text-align: center;
}

.tips-text {
  font-size: 12px;
  color: #ff7474;
  margin-left: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/components/departmentList/DepartmentTree.vue